import {Action} from '@ngrx/store';
import {PageSettings} from '../../model/page-settings.model';

/**
 * All actions of the offer sub-store are described here
 * An action can have an optional payload
 */

/**
 * @deprecated remove when UCS_539_SPLIT_WS_BID_STATUS_MESSAGE is removed
 */
export const UPDATE_BID_STATUS = '[OFFER] UPDATE_BID_STATUS';
export const UPDATE_BID_STATUS_GENERAL = '[OFFER] UPDATE_BID_STATUS_GENERAL';
export const UPDATE_BID_STATUS_DEALER_SPECIFIC = '[OFFER] UPDATE_BID_STATUS_DEALER_SPECIFIC';

export const UPDATE_OFFER = '[OFFER] UPDATE_OFFER';
export const UPDATED_OFFER = '[OFFER] UPDATED_OFFER';
export const UPDATE_BOOKMARKED_OFFERS_PIA = '[OFFER] UPDATE_BOOKMARKED_OFFERS_PIA';
export const UPDATED_BOOKMARKED_OFFERS_PIA = '[OFFER] UPDATED_BOOKMARKED_OFFERS_PIA';

export const UPDATE_BOOKMARKED_OFFERS_PB = '[OFFER] UPDATE_BOOKMARKED_OFFERS_PB';
export const UPDATED_BOOKMARKED_OFFERS_PB = '[OFFER] UPDATED_BOOKMARKED_OFFERS_PB';

export const UPDATE_BOOKMARKED_OFFERS_ALLUC = '[OFFER] UPDATE_BOOKMARKED_OFFERS_ALLUC';
export const UPDATED_BOOKMARKED_OFFERS_ALLUC = '[OFFER] UPDATED_BOOKMARKED_OFFERS_ALLUC';

export const UPDATE_BOOKMARKED_OFFERS_DINBIL = '[OFFER] UPDATE_BOOKMARKED_OFFERS_DINBIL';
export const UPDATED_BOOKMARKED_OFFERS_DINBIL = '[OFFER] UPDATED_BOOKMARKED_OFFERS_DINBIL';

export const UPDATE_BOOKMARKED_OFFERS_VGRX = '[OFFER] UPDATE_BOOKMARKED_OFFERS_VGRX';
export const UPDATED_BOOKMARKED_OFFERS_VGRX = '[OFFER] UPDATED_BOOKMARKED_OFFERS_VGRX';

export const UPDATE_CURRENT_USERCOMPANY_OFFERS_PIA = '[OFFER] UPDATE_CURRENT_USERCOMPANY_OFFERS_PIA';
export const UPDATED_CURRENT_USERCOMPANY_OFFERS_PIA = '[OFFER] UPDATED_CURRENT_USERCOMPANY_OFFERS_PIA';

export const UPDATE_CURRENT_USERCOMPANY_OFFERS_PB = '[OFFER] UPDATE_CURRENT_USERCOMPANY_OFFERS_PB';
export const UPDATED_CURRENT_USERCOMPANY_OFFERS_PB = '[OFFER] UPDATED_CURRENT_USERCOMPANY_OFFERS_PB';

export const UPDATE_CURRENT_USERCOMPANY_OFFERS_ALLUC = '[OFFER] UPDATE_CURRENT_USERCOMPANY_OFFERS_ALLUC';
export const UPDATED_CURRENT_USERCOMPANY_OFFERS_ALLUC = '[OFFER] UPDATED_CURRENT_USERCOMPANY_OFFERS_ALLUC';

export const UPDATE_CURRENT_USERCOMPANY_OFFERS_DINBIL = '[OFFER] UPDATE_CURRENT_USERCOMPANY_OFFERS_DINBIL';
export const UPDATED_CURRENT_USERCOMPANY_OFFERS_DINBIL = '[OFFER] UPDATED_CURRENT_USERCOMPANY_OFFERS_DINBIL';

export const UPDATE_CURRENT_USERCOMPANY_OFFERS_VGRX = '[OFFER] UPDATE_CURRENT_USERCOMPANY_OFFERS_VGRX';
export const UPDATED_CURRENT_USERCOMPANY_OFFERS_VGRX = '[OFFER] UPDATED_CURRENT_USERCOMPANY_OFFERS_VGRX';

export const UPDATE_FINISHED_USERCOMPANY_OFFERS_PIA = '[OFFER] UPDATE_FINISHED_USERCOMPANY_OFFERS_PIA';
export const UPDATED_FINISHED_USERCOMPANY_OFFERS_PIA = '[OFFER] UPDATED_FINISHED_USERCOMPANY_OFFERS_PIA';

export const UPDATE_FINISHED_USERCOMPANY_OFFERS_PB = '[OFFER] UPDATE_FINISHED_USERCOMPANY_OFFERS_PB';
export const UPDATED_FINISHED_USERCOMPANY_OFFERS_PB = '[OFFER] UPDATED_FINISHED_USERCOMPANY_OFFERS_PB';

export const UPDATE_FINISHED_USERCOMPANY_OFFERS_ALLUC = '[OFFER] UPDATE_FINISHED_USERCOMPANY_OFFERS_ALLUC';
export const UPDATED_FINISHED_USERCOMPANY_OFFERS_ALLUC = '[OFFER] UPDATED_FINISHED_USERCOMPANY_OFFERS_ALLUC';

export const UPDATE_FINISHED_USERCOMPANY_OFFERS_DINBIL = '[OFFER] UPDATE_FINISHED_USERCOMPANY_OFFERS_DINBIL';
export const UPDATED_FINISHED_USERCOMPANY_OFFERS_DINBIL = '[OFFER] UPDATED_FINISHED_USERCOMPANY_OFFERS_DINBIL';

export const UPDATE_FINISHED_USERCOMPANY_OFFERS_VGRX = '[OFFER] UPDATE_FINISHED_USERCOMPANY_OFFERS_VGRX';
export const UPDATED_FINISHED_USERCOMPANY_OFFERS_VGRX = '[OFFER] UPDATED_FINISHED_USERCOMPANY_OFFERS_VGRX';

export const UPDATE_VIEW_SETTINGS = '[OFFER] UPDATE_VIEW_SETTINGS';

export const UPDATE_PAGE_SETTINGS = '[OFFER] UPDATE_PAGE_SETTINGS';

export const UPDATE_PAGE_SETTINGS_PAGE = '[OFFER] UPDATE_PAGE_SETTINGS_PAGE';

export const UPDATE_PAGE_SETTINGS_CHANNEL = '[OFFER] UPDATE_PAGE_SETTINGS_CHANNEL';

export const UPDATE_AUCTION_BID = '[OFFER] UPDATE_AUCTION_BID';
export const UPDATED_AUCTION_BID = '[OFFER] UPDATED_AUCTION_BID';

/**
 * UPDATE ACTIONS
 */

// this actions are used in combination with web sockets, where we receive a bid [general | dealer specific] status dto and update the store with it
/**
 * @deprecated remove when UCS_539_SPLIT_WS_BID_STATUS_MESSAGE is removed
 */
export class UpdateBidStatusAction implements Action {
  readonly type = UPDATE_BID_STATUS;

  constructor(public payload: BidStatusDto) {
  }
}

export class UpdateBidStatusGeneralAction implements Action {
  readonly type = UPDATE_BID_STATUS_GENERAL;

  constructor(public payload: BidGeneralStatusDto) {
  }
}

export class UpdateBidStatusDealerSpecificAction implements Action {
  readonly type = UPDATE_BID_STATUS_DEALER_SPECIFIC;

  constructor(public payload: BidDealerStatusDto) {
  }
}

export class UpdateOfferAction implements Action {
  readonly type = UPDATE_OFFER;

  constructor(public id: number) {
  }
}

export class UpdateBookmarkedOffersPiaAction implements Action {
  readonly type = UPDATE_BOOKMARKED_OFFERS_PIA;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateBookmarkedOffersPbAction implements Action {
  readonly type = UPDATE_BOOKMARKED_OFFERS_PB;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateBookmarkedOffersAllUcAction implements Action {
  readonly type = UPDATE_BOOKMARKED_OFFERS_ALLUC;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateBookmarkedOffersDinBilAction implements Action {
  readonly type = UPDATE_BOOKMARKED_OFFERS_DINBIL;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateBookmarkedOffersVgrxAction implements Action {
  readonly type = UPDATE_BOOKMARKED_OFFERS_VGRX;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateCurrentUserCompanyOffersPiaAction implements Action {
  readonly type = UPDATE_CURRENT_USERCOMPANY_OFFERS_PIA;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateCurrentUserCompanyOffersPbAction implements Action {
  readonly type = UPDATE_CURRENT_USERCOMPANY_OFFERS_PB;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateCurrentUserCompanyOffersAllUcAction implements Action {
  readonly type = UPDATE_CURRENT_USERCOMPANY_OFFERS_ALLUC;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateCurrentUserCompanyOffersDinBilAction implements Action {
  readonly type = UPDATE_CURRENT_USERCOMPANY_OFFERS_DINBIL;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateCurrentUserCompanyOffersVgrxAction implements Action {
  readonly type = UPDATE_CURRENT_USERCOMPANY_OFFERS_VGRX;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateFinishedUserCompanyOffersPiaAction implements Action {
  readonly type = UPDATE_FINISHED_USERCOMPANY_OFFERS_PIA;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateFinishedUserCompanyOffersPbAction implements Action {
  readonly type = UPDATE_FINISHED_USERCOMPANY_OFFERS_PB;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateFinishedUserCompanyOffersAllUcAction implements Action {
  readonly type = UPDATE_FINISHED_USERCOMPANY_OFFERS_ALLUC;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateFinishedUserCompanyOffersDinBilAction implements Action {
  readonly type = UPDATE_FINISHED_USERCOMPANY_OFFERS_DINBIL;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateFinishedUserCompanyOffersVgrxAction implements Action {
  readonly type = UPDATE_FINISHED_USERCOMPANY_OFFERS_VGRX;

  constructor(public size?: number, public page?: number, public sort?: string, public order?: string) {
  }
}

export class UpdateViewSettings implements Action {
  readonly type = UPDATE_VIEW_SETTINGS;

  constructor(public settings: ViewTag[]) {
  }
}

export class UpdatePageSettings implements Action {
  readonly type = UPDATE_PAGE_SETTINGS;

  constructor(public payload: PageSettings) {
  }
}

export class UpdatePageSettingsPage implements Action {
  readonly type = UPDATE_PAGE_SETTINGS_PAGE;

  constructor(public page: number) {
  }
}

export class UpdatePageSettingsChannel implements Action {
  readonly type = UPDATE_PAGE_SETTINGS_CHANNEL;

  constructor(public channel: DistributionChannel) {
  }
}

/**
 * UPDATED ACTIONS
 */

export class UpdatedOfferAction implements Action {
  readonly type = UPDATED_OFFER;

  constructor(public payload: OfferDto) {
  }
}

export class UpdatedBookmarkedOffersPiaAction implements Action {
  readonly type = UPDATED_BOOKMARKED_OFFERS_PIA;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedBookmarkedOffersPbAction implements Action {
  readonly type = UPDATED_BOOKMARKED_OFFERS_PB;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedBookmarkedOffersAllUcAction implements Action {
  readonly type = UPDATED_BOOKMARKED_OFFERS_ALLUC;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedBookmarkedOffersDinBilAction implements Action {
  readonly type = UPDATED_BOOKMARKED_OFFERS_DINBIL;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedBookmarkedOffersVgrxAction implements Action {
  readonly type = UPDATED_BOOKMARKED_OFFERS_VGRX;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedCurrentUserCompanyOffersPiaAction implements Action {
  readonly type = UPDATED_CURRENT_USERCOMPANY_OFFERS_PIA;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedCurrentUserCompanyOffersPbAction implements Action {
  readonly type = UPDATED_CURRENT_USERCOMPANY_OFFERS_PB;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedCurrentUserCompanyOffersAllUcAction implements Action {
  readonly type = UPDATED_CURRENT_USERCOMPANY_OFFERS_ALLUC;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedCurrentUserCompanyOffersDinBilAction implements Action {
  readonly type = UPDATED_CURRENT_USERCOMPANY_OFFERS_DINBIL;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedCurrentUserCompanyOffersVgrxAction implements Action {
  readonly type = UPDATED_CURRENT_USERCOMPANY_OFFERS_VGRX;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedFinishedUserCompanyOffersPiaAction implements Action {
  readonly type = UPDATED_FINISHED_USERCOMPANY_OFFERS_PIA;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedFinishedUserCompanyOffersPbAction implements Action {
  readonly type = UPDATED_FINISHED_USERCOMPANY_OFFERS_PB;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedFinishedUserCompanyOffersAllUcAction implements Action {
  readonly type = UPDATED_FINISHED_USERCOMPANY_OFFERS_ALLUC;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedFinishedUserCompanyOffersDinBilAction implements Action {
  readonly type = UPDATED_FINISHED_USERCOMPANY_OFFERS_DINBIL;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdatedFinishedUserCompanyOffersVgrxAction implements Action {
  readonly type = UPDATED_FINISHED_USERCOMPANY_OFFERS_VGRX;

  constructor(public payload: OfferDto[]) {
  }
}

export class UpdateAuctionBidAction implements Action {
  readonly type = UPDATE_AUCTION_BID;

  constructor(public payload: number) {
  }
}

export class UpdatedAuctionBidAction implements Action {
  readonly type = UPDATED_AUCTION_BID;

  constructor(public payload: number) {
  }
}

export type OfferAction =
    UpdateBidStatusAction
    | UpdateBidStatusGeneralAction
    | UpdateBidStatusDealerSpecificAction
    | UpdateOfferAction
    | UpdatedOfferAction
    | UpdateBookmarkedOffersPiaAction
    | UpdatedBookmarkedOffersPiaAction
    | UpdateBookmarkedOffersPbAction
    | UpdatedBookmarkedOffersPbAction
    | UpdateBookmarkedOffersAllUcAction
    | UpdatedBookmarkedOffersAllUcAction
    | UpdateBookmarkedOffersDinBilAction
    | UpdatedBookmarkedOffersDinBilAction
    | UpdateBookmarkedOffersVgrxAction
    | UpdatedBookmarkedOffersVgrxAction
    | UpdateCurrentUserCompanyOffersPiaAction
    | UpdatedCurrentUserCompanyOffersPiaAction
    | UpdateCurrentUserCompanyOffersPbAction
    | UpdatedCurrentUserCompanyOffersPbAction
    | UpdateCurrentUserCompanyOffersAllUcAction
    | UpdatedCurrentUserCompanyOffersAllUcAction
    | UpdateCurrentUserCompanyOffersDinBilAction
    | UpdatedCurrentUserCompanyOffersDinBilAction
    | UpdateCurrentUserCompanyOffersVgrxAction
    | UpdatedCurrentUserCompanyOffersVgrxAction
    | UpdateFinishedUserCompanyOffersPiaAction
    | UpdatedFinishedUserCompanyOffersPiaAction
    | UpdateFinishedUserCompanyOffersPbAction
    | UpdatedFinishedUserCompanyOffersPbAction
    | UpdateFinishedUserCompanyOffersAllUcAction
    | UpdatedFinishedUserCompanyOffersAllUcAction
    | UpdateFinishedUserCompanyOffersDinBilAction
    | UpdatedFinishedUserCompanyOffersDinBilAction
    | UpdateFinishedUserCompanyOffersVgrxAction
    | UpdatedFinishedUserCompanyOffersVgrxAction
    | UpdateViewSettings
    | UpdatePageSettings
    | UpdatePageSettingsPage
    | UpdatePageSettingsChannel
    | UpdateAuctionBidAction
    | UpdatedAuctionBidAction;
